import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { DateRangePickerTextField } from "@styleguide";
import { type FieldValues, type Path, type PathValue, useController } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

type TStoredRange = { startDate?: string; endDate?: string };

const toDate = (value?: string): Date | null => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const toISO = (date: Date | null): string | undefined => (date ? date.toISOString() : undefined);

export const FormGenInputDateRange = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
  jsonSchemaElement,
}: IFormGenInputProps<Schema, T>) => {
  const allowOpenEnded = jsonSchemaElement.dateRange?.allowOpenEnded;
  const { field, fieldState } = useController({
    control,
    name: uiSchemaElement.scope as unknown as Path<T>,
    defaultValue: {} as PathValue<T, Path<T>>,
  });
  const value = (field.value ?? {}) as TStoredRange;

  return (
    <DateRangePickerTextField
      label={uiSchemaElement.label}
      fullWidth
      value={{ startDate: toDate(value.startDate), endDate: toDate(value.endDate) }}
      onChange={(range) => field.onChange({ startDate: toISO(range.startDate), endDate: toISO(range.endDate) })}
      onBlur={field.onBlur}
      required={{ startDate: true, endDate: !allowOpenEnded }}
      error={Boolean(fieldState.error)}
      helperText={fieldState.error?.message}
    />
  );
};
